import { render, staticRenderFns } from "./partmodule.vue?vue&type=template&id=081a80fc&scoped=true&"
import script from "./partmodule.vue?vue&type=script&lang=js&"
export * from "./partmodule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a80fc",
  null
  
)

export default component.exports